<!-- 
    通用定位组件(参数type:资源类型（资源类型就是在五个一控制台配置图层时选择的类型）,objid:资源的对象ID)
    mode:模式:web/h5，在显示上有所区别，例如h5里面不显示zoom控件
-->
<template>
  <div class="dhmap-wrapper">
    <div id="locatemap" ref="locatemap" v-resize="resize"></div>
    <div id="marker1" title="Marker" style="height:50px;width:100px;"></div>
    <div id="marker2" title="Marker" style="height:50px;width:100px;"></div>
    <!-- 因数据安全需要，已设置安全限制GIS数据将无法访问和查看！ -->
    <van-notice-bar left-icon="volume-o" :scrollable="false" class="vanSwipe" v-if="isFilter">
      <van-swipe
        vertical
        class="noticeSwiper"
        :autoplay="3000"
        :show-indicators="false"
      >
        <van-swipe-item
          >因数据安全需要，已设置安全限制GIS数据将无法访问和查看！</van-swipe-item
        >
        <van-swipe-item
          >因数据安全需要，已设置安全限制GIS数据将无法访问和查看！</van-swipe-item
        >
        <van-swipe-item
          >因数据安全需要，已设置安全限制GIS数据将无法访问和查看！</van-swipe-item
        >
      </van-swipe>
    </van-notice-bar>
  </div>
</template>

<script>
/* eslint-disable */
import { mapState } from 'vuex'
import 'ol/ol.css';
import {initMap,addLayerToMap,addLocateLayerToMap,actLocate,mapalert,addMarkerLayerToMap,getLocateLayer} from '@/utils/MapUtils'

export default {
  name: "map-locator",
  components: {},
  props: {
    param: { type: Object, default: () => {return {}}},
    mode: { type: String, default: "web" }
  },
  data() {
    return {
      map:null,
      gisconfig:{},
      dataGisType:["geo_xiaoban","geo_shidi","geo_baohudi","geo_jbntbhtb","geo_hongxian"],//脱敏gis图层，脱敏的图层不展示
      isFilter:false,//是否脱敏提示
    }
  },
  mounted(){
    this.loadMap()
  },
  methods:{
    userDataPermission(){
      let _this=this;
      _this.$api.User.userDataPermission(_this.userinfo.uid).then(res=>{
        if(res && res.code == 1){
          _this.dataGisType=res.data.dataType;
          actLocate(_this.map,_this.param.type,_this.param.objid,null,(target)=>{
            let type=_this.param.type.substring(4);
            if(_this.dataGisType.indexOf(type)==-1){
              _this.isFilter=true;
              let vectorSource = getLocateLayer(_this.map).getSource();
              vectorSource.clear();
            }
          });
        }else{
          mapalert(res.msg);
        }
      })
    },
    loadMap(){
      var _this = this;
      if(_this.userinfo && _this.userinfo.appId){
        this.$api.Mapapi.getconfig({
          'appId': _this.userinfo.appId,
        }).then(res => {
          if (res && res.code==1) {
            _this.gisconfig = res.data
            //设置该地图根据CQL进行过滤加载
            _this.gisconfig.queryWithCQL = true 
            //设置CQL进行查询，必须要提供uid、uregion、uregionlevel三个参数
            _this.gisconfig.uid=_this.userinfo.uid
            _this.gisconfig.uregion=_this.userinfo.zqCode
            _this.gisconfig.uregionlevel=[null,1,1,2,2,3,3,4,4,4,5,5,5,5,5][_this.gisconfig.uregion.length]
            //初始化地图
            if(this.mode == 'h5'){
              _this.map = initMap('locatemap',_this.gisconfig,{showZoom:false})
            }else{
              _this.map = initMap('locatemap',_this.gisconfig)
            }
            _this.map.gisConfig = res.data
            //添加图层
            addLayerToMap(_this.map,_this.gisconfig,null,['geo_sheng','geo_shi','geo_xian','geo_xiang','geo_cun'])
            addLocateLayerToMap(_this.map)
            addMarkerLayerToMap(_this.map)
            //调用MapUtil添加图层
            if(_this.param.type=='geo_xiaoban'|| 
                _this.param.type=='geo_baohudi'||
                _this.param.type=='geo_jbntbhtb'||
                _this.param.type=='geo_hongxian'||
                _this.param.type=='geo_shidi'){//如果是五个保密数据类型：小班、湿地、基本农田、生态红线、自然保护地要进行脱敏判断
                _this.userDataPermission();//获取脱敏的数据接口
            }else{//不需要脱敏，直接定位
              actLocate(_this.map,_this.param.type,_this.param.objid)
            }
            
          } else {
              mapalert(res.msg)
          }
        }).catch((err) => {mapalert('定位类型不存在!')})
      }
    },
    resize(){
      var _this = this
      setTimeout( function() { _this.map.updateSize();}, 200);
    }
  },
  computed: {
      ...mapState(['userinfo'])
  },
  watch:{
    param (val) {
      actLocate(this.map,val.type,val.objid)
    },
    userinfo(){
      this.loadMap()
    }
  },
  directives: {  // 使用局部注册指令的方式
    resize: { // 指令的名称
      bind(el, binding) { // el为绑定的元素，binding为绑定给指令的对象
        let width = '', height = '';
        function isReize() {
          const style = document.defaultView.getComputedStyle(el);
          if (width !== style.width || height !== style.height) {
            binding.value();  // 关键
          }
          width = style.width;
          height = style.height;
        }
        el.__vueSetInterval__ = setInterval(isReize, 300);
      },
      unbind(el) {
        clearInterval(el.__vueSetInterval__);
      }
    }
  }
}
</script>

<style scoped lang="less">
#locatemap{
  width:100%;
  height:100%;
}
.dhmap-wrapper{
  position: relative;
}
.vanSwipe {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: #4bc985;
    height: 30px;
    .van-icon{
      color:#fff;
    }
    .van-notice-bar__wrap {
      height: 25px;
    }
    .noticeSwiper {
      font-size: 12px;
      width: 350px;
      height: 25px;
      line-height: 25px;
      color: #fff;
      background: #4bc985;
      position: relative;
    }
  }
</style>